export const environment = {
  production: false,
  backendUrl: 'https://dev-backend.ailens.ai',
  osburl: 'https://dev-osb.ailens.ai',
  tag: 'docker',
  defaultProvider: 'openrouter',
  userMcpMicroserviceUrl: 'https://dev-usermcpserver.ailens.ai',
  messageLength: 8,
  slicedLength: 4,
};
